var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 468;
var h = 468;
var nm = "Bank noout blue";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "roof",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 31,
                        s: [
                            233.098,
                            253.03,
                            0
                        ],
                        to: [
                            0,
                            -11.167,
                            0
                        ],
                        ti: [
                            0,
                            11.167,
                            0
                        ]
                    },
                    {
                        t: 43.0000017514259,
                        s: [
                            233.098,
                            186.03,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 31,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -67.065,
                                                    19.268
                                                ],
                                                [
                                                    67.065,
                                                    19.268
                                                ],
                                                [
                                                    -0.328,
                                                    19.732
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                },
                                {
                                    t: 43.0000017514259,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -67.065,
                                                    19.268
                                                ],
                                                [
                                                    67.065,
                                                    19.268
                                                ],
                                                [
                                                    -0.213,
                                                    -19.268
                                                ]
                                            ],
                                            c: true
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 931.000037920407,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Stroked 8",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    290.582,
                    240.746,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        31.403
                                    ],
                                    [
                                        0,
                                        -31.403
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 31,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 43.0000017514259,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 931.000037920407,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Stroked 7",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    252.259,
                    240.746,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        31.403
                                    ],
                                    [
                                        0,
                                        -31.403
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Stroked 8').content('Trim Paths 1').end;"
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 931.000037920407,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Stroked 6",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    213.937,
                    240.746,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        31.403
                                    ],
                                    [
                                        0,
                                        -31.403
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Stroked 8').content('Trim Paths 1').end;"
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 931.000037920407,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Stroked 5",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    175.614,
                    240.746,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        31.403
                                    ],
                                    [
                                        0,
                                        -31.403
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 2",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('Stroked 8').content('Trim Paths 1').end;"
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 31.0000012626559,
        op: 931.000037920407,
        st: 31.0000012626559,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Stroked 3",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.098,
                    272.506,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                126.898,
                                0
                            ],
                            [
                                0,
                                -126.898
                            ],
                            [
                                -126.898,
                                0
                            ],
                            [
                                0,
                                126.898
                            ]
                        ],
                        o: [
                            [
                                -126.898,
                                0
                            ],
                            [
                                0,
                                126.898
                            ],
                            [
                                126.898,
                                0
                            ],
                            [
                                0,
                                -126.898
                            ]
                        ],
                        v: [
                            [
                                -1.465,
                                -268.737
                            ],
                            [
                                -231.235,
                                -38.967
                            ],
                            [
                                -1.465,
                                190.802
                            ],
                            [
                                228.304,
                                -38.967
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 11,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    259.935,
                                                    -0.481
                                                ],
                                                [
                                                    276.065,
                                                    -0.494
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 22,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -67.065,
                                                    0
                                                ],
                                                [
                                                    271.065,
                                                    -0.494
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -67.065,
                                                    0
                                                ],
                                                [
                                                    67.065,
                                                    0
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 11.0000004480392,
        op: 911.000037105791,
        st: 11.0000004480392,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Stroked 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233.098,
                    301.035,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                126.898,
                                0
                            ],
                            [
                                0,
                                -126.898
                            ],
                            [
                                -126.898,
                                0
                            ],
                            [
                                0,
                                126.898
                            ]
                        ],
                        o: [
                            [
                                -126.898,
                                0
                            ],
                            [
                                0,
                                126.898
                            ],
                            [
                                126.898,
                                0
                            ],
                            [
                                0,
                                -126.898
                            ]
                        ],
                        v: [
                            [
                                0.535,
                                -297.737
                            ],
                            [
                                -229.235,
                                -67.967
                            ],
                            [
                                0.535,
                                161.802
                            ],
                            [
                                230.304,
                                -67.967
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 11,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -274.065,
                                                    0.035
                                                ],
                                                [
                                                    -259.935,
                                                    0.035
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.667,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.333,
                                        y: 0
                                    },
                                    t: 22,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -274.065,
                                                    0.035
                                                ],
                                                [
                                                    67.065,
                                                    0
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                },
                                {
                                    t: 29.0000011811942,
                                    s: [
                                        {
                                            i: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            o: [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            v: [
                                                [
                                                    -67.065,
                                                    0
                                                ],
                                                [
                                                    67.065,
                                                    0
                                                ]
                                            ],
                                            c: false
                                        }
                                    ]
                                }
                            ],
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 11.0000004480392,
        op: 911.000037105791,
        st: 11.0000004480392,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    2500,
                    2500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ]
                        ],
                        o: [
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ]
                        ],
                        v: [
                            [
                                2500,
                                2270
                            ],
                            [
                                2270,
                                2500
                            ],
                            [
                                2500,
                                2730
                            ],
                            [
                                2730,
                                2500
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ty: "gr",
                                it: [
                                    {
                                        ty: "gr",
                                        it: [
                                            {
                                                ty: "gr",
                                                it: [
                                                    {
                                                        ty: "gr",
                                                        it: [
                                                            {
                                                                ind: 0,
                                                                ty: "sh",
                                                                ix: 1,
                                                                ks: {
                                                                    a: 0,
                                                                    k: {
                                                                        i: [
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        o: [
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ]
                                                                        ],
                                                                        v: [
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        c: true
                                                                    },
                                                                    ix: 2
                                                                },
                                                                nm: "Path 1",
                                                                mn: "ADBE Vector Shape - Group",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "fl",
                                                                c: {
                                                                    a: 0,
                                                                    k: [
                                                                        0.945098039216,
                                                                        0.972549019608,
                                                                        1,
                                                                        1
                                                                    ],
                                                                    ix: 4
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 5
                                                                },
                                                                r: 1,
                                                                bm: 0,
                                                                nm: "Fill 1",
                                                                mn: "ADBE Vector Graphic - Fill",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "tr",
                                                                p: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 2
                                                                },
                                                                a: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 1
                                                                },
                                                                s: {
                                                                    a: 0,
                                                                    k: [
                                                                        100,
                                                                        100
                                                                    ],
                                                                    ix: 3
                                                                },
                                                                r: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 6
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 7
                                                                },
                                                                sk: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 4
                                                                },
                                                                sa: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 5
                                                                },
                                                                nm: "Transform"
                                                            }
                                                        ],
                                                        nm: "Rectangle",
                                                        np: 2,
                                                        cix: 2,
                                                        bm: 0,
                                                        ix: 1,
                                                        mn: "ADBE Vector Group",
                                                        hd: false
                                                    },
                                                    {
                                                        ty: "tr",
                                                        p: {
                                                            a: 0,
                                                            k: [
                                                                500,
                                                                500
                                                            ],
                                                            ix: 2
                                                        },
                                                        a: {
                                                            a: 0,
                                                            k: [
                                                                0,
                                                                0
                                                            ],
                                                            ix: 1
                                                        },
                                                        s: {
                                                            a: 0,
                                                            k: [
                                                                100,
                                                                100
                                                            ],
                                                            ix: 3
                                                        },
                                                        r: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 6
                                                        },
                                                        o: {
                                                            a: 0,
                                                            k: 100,
                                                            ix: 7
                                                        },
                                                        sk: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 4
                                                        },
                                                        sa: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 5
                                                        },
                                                        nm: "Transform"
                                                    }
                                                ],
                                                nm: "icon/2tone/bank",
                                                np: 1,
                                                cix: 2,
                                                bm: 0,
                                                ix: 1,
                                                mn: "ADBE Vector Group",
                                                hd: false
                                            },
                                            {
                                                ty: "tr",
                                                p: {
                                                    a: 0,
                                                    k: [
                                                        500,
                                                        500
                                                    ],
                                                    ix: 2
                                                },
                                                a: {
                                                    a: 0,
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    ix: 1
                                                },
                                                s: {
                                                    a: 0,
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    ix: 3
                                                },
                                                r: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 6
                                                },
                                                o: {
                                                    a: 0,
                                                    k: 100,
                                                    ix: 7
                                                },
                                                sk: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 4
                                                },
                                                sa: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 5
                                                },
                                                nm: "Transform"
                                            }
                                        ],
                                        nm: "Group",
                                        np: 1,
                                        cix: 2,
                                        bm: 0,
                                        ix: 1,
                                        mn: "ADBE Vector Group",
                                        hd: false
                                    },
                                    {
                                        ty: "tr",
                                        p: {
                                            a: 0,
                                            k: [
                                                500,
                                                500
                                            ],
                                            ix: 2
                                        },
                                        a: {
                                            a: 0,
                                            k: [
                                                0,
                                                0
                                            ],
                                            ix: 1
                                        },
                                        s: {
                                            a: 0,
                                            k: [
                                                100,
                                                100
                                            ],
                                            ix: 3
                                        },
                                        r: {
                                            a: 0,
                                            k: 0,
                                            ix: 6
                                        },
                                        o: {
                                            a: 0,
                                            k: 100,
                                            ix: 7
                                        },
                                        sk: {
                                            a: 0,
                                            k: 0,
                                            ix: 4
                                        },
                                        sa: {
                                            a: 0,
                                            k: 0,
                                            ix: 5
                                        },
                                        nm: "Transform"
                                    }
                                ],
                                nm: "icon/2tone/bank",
                                np: 1,
                                cix: 2,
                                bm: 0,
                                ix: 1,
                                mn: "ADBE Vector Group",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        500,
                                        500
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "lending-platforms",
                        np: 1,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "usecase-accept1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var BankBlue = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, BankBlue as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=BankBlue.json.es.js.map
